import React from 'react';
import classnames from 'classnames/bind';
import { Button } from '@components';
import { Input } from 'gd-design-library';
import styles from './CouponCode.module.scss';
import { DiscountCode } from '@services/cart';
import { DiscountCodeReference } from '@commercetools/platform-sdk';

const cx = classnames.bind(styles);

const CN = 'coupon-code';
const inputContainerClassName = `${CN}__input-container`;
const discountContainerClassName = `${CN}__discount-container`;
const removeButtonClassName = `${discountContainerClassName}__button`;
const inputClassName = `${inputContainerClassName}__input`;
const buttonClassName = `${inputContainerClassName}__button`;

interface CouponCodeProps {
  discountCodes?: DiscountCode[];
  removeDiscountCode: (discountCode: DiscountCodeReference) => Promise<void>;
  addDiscountCode: (discountCode: string) => Promise<void>;
  isLoading: boolean;
}

export const CouponCode: React.FC<CouponCodeProps> = ({
  discountCodes,
  addDiscountCode,
  removeDiscountCode,
  isLoading
}) => {
  const [ value, setValue ] = React.useState('');

  const apply = (): Promise<void> => addDiscountCode(value);

  return (
    <div className={ cx(CN) }>
      <div className={ cx(inputContainerClassName) }>
        <Input
          className={ cx(inputClassName) }
          name='promoCode'
          variant='text'
          placeholder='Enter promo code'
          value={ value }
          onChange={ (e): void => setValue((e.target as HTMLInputElement).value) }
          onKeyDown={ (e): void => {
            if (e.key === 'Enter' && value) apply();
          } }
        />
        <Button
          loading={ isLoading }
          onClick={ apply }
          className={ cx(buttonClassName) }
          disabled={ !value }
        >
          Apply
        </Button>
      </div>

      {discountCodes?.map(({ discountCodeRef, discountCode }) => (
        <div className={ cx(discountContainerClassName) } key={ discountCode.name }>
          <div>{`Discount "${discountCode.code}":`}</div>
          <Button
            loading={ isLoading }
            className={ cx(removeButtonClassName) }
            variant='text'
            onClick={ (): Promise<void> => removeDiscountCode(discountCodeRef) }
          >
            Remove
          </Button>
        </div>
      ))}
    </div>
  );
};
